import React, { Fragment, useState, useEffect, useRef } from "react";
import { useParams, NavLink, useHistory } from "react-router-dom";

import MakeAPICall from "../../apiCalls/common";

import {
  getDoctorBookingsApiRoute,
  editDoctorProfileApiRoute,
  getPaymentSummariesListNew,
  getDbFormsApi,
  getMonthlyConsultApi,
  uploadMedicareConsultNoteCSVApiRoute
} from "../../apiRoutes";

import { consultNoteGenerateHTMLCode } from "../../utils/consultNotePDF";

import { generateTaxInvoiceHTMLCode } from "../../utils/doctorInvoiceSummaryPDF";

// import {
//   getStateListApiRoute,
//   getDoctorBookingsApiRoute,
//   editDoctorProfileApiRoute,
//   getPaymentSummariesListNew,
//   ,
//   getMonthlyConsultApi,
//   uploadMedicareConsultNoteCSVApiRoute
// } from "../../apiRoutes";

import {
  getAgeByYears,
  getWeekDay,
  getFormattedMonthDate,
  getFormattedMonthDateV3
} from "../../utils/dateTimeHelper";

import menuSVG from "../../assets/images/menu.svg";

import appRoutes from "../../routes/appRoutes";

import {
  mapDoctorDetailsIncomingData,
  mapDoctorProfileSubmitData
} from "./doctorDetailsDataMapping";

import Loader from "../../components/loader";
import CustomModal from "../../components/modal";
import DoctorProfileForm from "../../containers/DoctorForms/doctorProfileForm";

import MonthlySummaryModel from "../../containers/MonthlyPaymentSummaryModel";
import MonthlyDB4Forms from "../../containers/MonthlyDB4Forms";

import moment from "moment";
import { CSVLink } from "react-csv";
import html2pdf from "html2pdf.js";
import { set } from "lodash";
import _ from "lodash";

import { generateHTMLCode } from "../../utils/doctorSummaryPDF";
import UploadMedicareConsultCSVForm from "../../containers/UploadMedicareAuditCSV";
import { STATE_LIST } from "../../constants/constants";

import EnvalopePNG from "../../assets/images/envelope.png";

const DoctorRejectedDetail = props => {
  let history = useHistory();
  let { id } = useParams();

  const [isProcessing, setIsProcessing] = useState(false);
  const [apiCallParams1, setApiCallParams1] = useState(null);
  const [apiCallParams3, setApiCallParams3] = useState(null);
  const [apiCallParams4, setApiCallParams4] = useState(null);
  const [apiCallParams5, setApiCallParams5] = useState(null);
  const [data, setData] = useState(null);
  const [showSuccModal, setShowSuccModal] = useState(false);
  const [succModalText, setSuccModalText] = useState("");
  const [showErrModal, setShowErrModal] = useState(false);
  const [errModalText, setErrModalText] = useState("");

  const [openMonthlySummaryModel, setOpenMonthlySummaryModel] = useState(false);
  const [monthlySummaryCSV, setMonthlySummaryCSV] = useState([]);
  const [monthlyConsultCSV, setMonthlyConsultCSV] = useState([]);
  const csvDownRef = useRef(null);
  const csvInput = useRef(null);
  const [headers, setHeaders] = useState([
    { label: "Payment Summary", key: "appointmentId" },
    { label: "Date", key: "createdAt" },
    { label: "Consult Cost", key: "appointmentPrice" },
    { label: "PM Fee", key: "PMFeeAmount" },
    { label: "GST On PM Fee", key: "taxAmount" },
    { label: "Earnings", key: "earnings" }
  ]);

  const [taxInvoiceHeaders, setTaxInvoiceHeaders] = useState([
    { label: "Tax Invoice", key: "appointmentId" },
    { label: "Date", key: "createdAt" },
    { label: "PM Fee", key: "PMFeeAmount" },
    { label: "GST On PM Fee", key: "taxAmount" },
    { label: "Total Invoice", key: "totalInvoice" }
  ]);

  const [headersConsult, setHeadersConsult] = useState([
    { label: "Date of Consult", key: "createdAt" },
    { label: "First Name", key: "firstName" },
    { label: "Last Name", key: "lastName" },
    { label: "Date of Birth", key: "dob" },
    { label: "Patient Declaration", key: "patientDeclaration" },
    { label: "URL", key: "url" }
  ]);

  const [openMonthlyDB4Forms, setOpenMonthlyDB4Forms] = useState(false);
  const [openMonthlyConsults, setOpenMonthlyConsults] = useState(false);
  const [noDataFoundDB4, setNoDataFoundDB4] = useState(false);
  const csvDownRefMonthlyConsult = useRef(null);
  const [uploadConsultNoteCSVModal, setUploadConsultNoteCSVModal] = useState(
    false
  );

  const [consultDataForGeneratePDFs, setConsultDataForGeneratePDFs] = useState(
    []
  );
  const [consultDataNotFoundPDF, setConsultDataNotFoundPDF] = useState([]);
  const [
    consultDataContinueProcessModal,
    setConsultDataContinueProcessModal
  ] = useState(false);


  // get doctor details
  const getDetails = async () => {
    let params = {
      skip: 10,
      limit: 0,
      doctorId: id
    };

    await setApiCallParams1({
      reqType: "GET",
      reqUrl: getDoctorBookingsApiRoute,
      params: params,
      successCallback: async res => {
        let data = await mapDoctorDetailsIncomingData(
          res.data.data.doctorDetails
        );

        setData(data);
        setIsProcessing(false);
      },
      failureCallback: err => {
        setIsProcessing(false);
        // setErrModalText(
        //   "Please try again. Please contact Instant Consult Support on 1300 003 310 if this issue persists."
        // );
        // setShowErrModal(true);
      }
    });
  };

  useEffect(() => {
    getDetails();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onFormSubmit = values => {
    setIsProcessing(true);

    let formData = mapDoctorProfileSubmitData(values, data._id);

    setApiCallParams1({
      reqType: "PUT",
      reqUrl: editDoctorProfileApiRoute,
      dataObj: formData,
      successCallback: res => {
        setIsProcessing(false);
        setSuccModalText("Doctor's Details Saved Successfully");
        setShowSuccModal(true);
      },
      failureCallback: err => {
        setIsProcessing(false);
        //setErrModalText(err.message);
        //setShowErrModal(true);
      }
    });
  };

  const onCancelForm = () => {
    history.push(appRoutes.doctorRejected, {
      currPageNo:
        props.location.state && props.location.state.currPageNo
          ? props.location.state.currPageNo
          : null
    });
  };

  const exportMonthlySummary = () => {
    setOpenMonthlySummaryModel(true);
  };

  // const downloadMonthlySummary = formValue => {
  //   setIsProcessing(true);
  //   let startDate = moment([formValue.year, formValue.month - "1"]),
  //     endDate = moment(startDate).endOf("month");
  //   let paramData = {
  //     startDate: moment(startDate)
  //       .add(0, "d")
  //       .toISOString(),
  //     endDate: endDate.toISOString(),
  //     doctorId: id
  //   };

  //   setApiCallParams3({
  //     reqType: "GET",
  //     reqUrl: getPaymentSummariesListNew,
  //     params: paramData,
  //     successCallback: res => {
  //       let monthlySummaryDataFormat = [],
  //         totalConsultConst = 0,
  //         totalPMFee = 0,
  //         totalTax = 0,
  //         totalEarnings = 0,
  //         rows = "";
  //       res.data.data.paymentHistory.map((value, index) => {
  //         let earnings = (
  //             value.appointmentPrice +
  //             (value.isBulkIncentiveAdded !== undefined &&
  //             value.isBulkIncentiveAdded === true
  //               ? value.bulkIncentiveDetails.price
  //               : 0) -
  //             value.PMFeeAmount -
  //             value.taxAmount
  //           ).toFixed(2),
  //           createdAt = moment(value.createdAt).format("DD-MM-YYYY");

  //         totalConsultConst =
  //           totalConsultConst + Number(value.appointmentPrice);
  //         totalPMFee = totalPMFee + Number(value.PMFeeAmount);
  //         totalTax = totalTax + Number(value.taxAmount);
  //         totalEarnings = totalEarnings + Number(earnings);

  //         let appPrice = Number(value.appointmentPrice);

  //         if (
  //           value.isBulkIncentiveAdded !== undefined &&
  //           value.isBulkIncentiveAdded === true
  //         ) {
  //           totalConsultConst =
  //             totalConsultConst + value.bulkIncentiveDetails.price;
  //           appPrice = appPrice + value.bulkIncentiveDetails.price;
  //         }

  //         monthlySummaryDataFormat.push({
  //           appointmentId: value.appointmentId,
  //           createdAt: moment(value.createdAt).format("DD-MM-YYYY"),
  //           appointmentPrice: "$" + appPrice.toFixed(2),
  //           PMFeeAmount: "$" + value.PMFeeAmount.toFixed(2),
  //           taxAmount: "$" + value.taxAmount.toFixed(2),
  //           earnings: "$" + earnings
  //         });

  //         rows += "<tr>";
  //         rows +=
  //           "<td>" +
  //           value.appointmentId +
  //           "</td>" +
  //           "<td>" +
  //           createdAt +
  //           "</td>" +
  //           "<td> $ " +
  //           appPrice +
  //           "</td>" +
  //           "<td> $ " +
  //           value.PMFeeAmount +
  //           "</td>" +
  //           "<td> $ " +
  //           value.taxAmount +
  //           "</td>" +
  //           "<td> $ " +
  //           earnings +
  //           "</td>";
  //         rows += "</tr>";
  //       });
  //       if (formValue.csv) {
  //         monthlySummaryDaFtaFormat.push({
  //           appointmentId: "-",
  //           createdAt: "-",
  //           appointmentPrice: "$" + totalConsultConst.toFixed(2),
  //           PMFeeAmount: "$" + totalPMFee.toFixed(2),
  //           taxAmount: "$" + totalTax.toFixed(2),
  //           earnings: "$" + totalEarnings.toFixed(2)
  //         });
  //         setMonthlySummaryCSV(monthlySummaryDataFormat);
  //         setTimeout(() => {
  //           csvDownRef.current.link.click();
  //         }, 2000);
  //       }
  //       if (formValue.pdf) {
  //         let months = [
  //           "January",
  //           "February",
  //           "March",
  //           "April",
  //           "May",
  //           "June",
  //           "July",
  //           "August",
  //           "September",
  //           "October",
  //           "November",
  //           "December"
  //         ];
  //         let element = generateHTMLCode(
  //           res.data.data.paymentHistory.length,
  //           months[+formValue.month - 1],
  //           formValue.year,
  //           data.fname + " " + data.lname,
  //           // this.state.doctorName,
  //           data.abn,
  //           data.un,
  //           data.streetName,
  //           data.suburb,
  //           data.state,
  //           data.postCode,
  //           data.email,
  //           rows,
  //           totalConsultConst,
  //           totalConsultConst,
  //           totalPMFee,
  //           totalTax,
  //           totalEarnings,
  //           "support@instantconsult.com.au",
  //           "1300 003 310"
  //         );
  //         let docH = 350;
  //         let docW = 600;
  //         html2pdf(element, {
  //           margin: 1,
  //           filename: "MonthlySummary.pdf",
  //           image: { type: "jpeg", quality: 1 },
  //           html2canvas: { letterRendering: false, docH, docW, scale: 2 },
  //           jsPDF: { unit: "mm", format: [docH, docW], orientation: "l" }
  //         });
  //       }
  //       closeSummaryModal();
  //       setIsProcessing(false);
  //     },
  //     failureCallback: err => {
  //       setIsProcessing(false);
  //       setErrModalText(
  //         "Please try again. Please contact Instant Consult Support on 1300 003 310 if this issue persists."
  //       );
  //       setShowErrModal(true);
  //     }
  //   });
  // };

  
  const downloadMonthlySummary = formValue => {
    console.log("Hey here: ", formValue);
    setIsProcessing(true);

    if (formValue.which === "payment_summary") {
      let startDate = moment([formValue.year, formValue.month - "1"]),
        endDate = moment(startDate).endOf("month");
      let paramData = {
        startDate: moment(startDate)
          .add(0, "d")
          .toISOString(),
        endDate: endDate.toISOString(),
        doctorId: id
      };

      setApiCallParams3({
        reqType: "GET",
        reqUrl: getPaymentSummariesListNew,
        params: paramData,
        successCallback: res => {
          let monthlySummaryDataFormat = [],
            totalConsultConst = 0,
            totalPMFee = 0,
            totalTax = 0,
            totalEarnings = 0,
            rows = "";
          res.data.data.paymentHistory.map((value, index) => {
            let earnings = (
                value.appointmentPrice +
                (value.isBulkIncentiveAdded !== undefined &&
                value.isBulkIncentiveAdded === true
                  ? value.bulkIncentiveDetails.price
                  : 0) -
                value.PMFeeAmount -
                value.taxAmount
              ).toFixed(2),
              createdAt = moment(value.createdAt).format("DD-MM-YYYY");

            totalConsultConst =
              totalConsultConst + Number(value.appointmentPrice);
            totalPMFee = totalPMFee + Number(value.PMFeeAmount);
            totalTax = totalTax + Number(value.taxAmount);
            totalEarnings = totalEarnings + Number(earnings);

            let appPrice = Number(value.appointmentPrice);

            if (
              value.isBulkIncentiveAdded !== undefined &&
              value.isBulkIncentiveAdded === true
            ) {
              totalConsultConst =
                totalConsultConst + value.bulkIncentiveDetails.price;
              appPrice = appPrice + value.bulkIncentiveDetails.price;
            }

            monthlySummaryDataFormat.push({
              appointmentId: value.appointmentId,
              createdAt: moment(value.createdAt).format("DD-MM-YYYY"),
              appointmentPrice: "$" + appPrice.toFixed(2),
              PMFeeAmount: "$" + value.PMFeeAmount.toFixed(2),
              taxAmount: "$" + value.taxAmount.toFixed(2),
              earnings: "$" + earnings
            });

            rows += "<tr>";
            rows +=
              "<td>" +
              value.appointmentId +
              "</td>" +
              "<td>" +
              createdAt +
              "</td>" +
              "<td> $ " +
              appPrice +
              "</td>" +
              "<td> $ " +
              value.PMFeeAmount +
              "</td>" +
              "<td> $ " +
              value.taxAmount +
              "</td>" +
              "<td> $ " +
              earnings +
              "</td>";
            rows += "</tr>";
          });
          if (formValue.csv) {
            monthlySummaryDataFormat.push({
              appointmentId: "-",
              createdAt: "-",
              appointmentPrice: "$" + totalConsultConst.toFixed(2),
              PMFeeAmount: "$" + totalPMFee.toFixed(2),
              taxAmount: "$" + totalTax.toFixed(2),
              earnings: "$" + totalEarnings.toFixed(2)
            });
            setMonthlySummaryCSV(monthlySummaryDataFormat);
            setTimeout(() => {
              csvDownRef.current.link.click();
            }, 2000);
          }
          if (formValue.pdf) {
            let months = [
              "January",
              "February",
              "March",
              "April",
              "May",
              "June",
              "July",
              "August",
              "September",
              "October",
              "November",
              "December"
            ];
            let element = generateHTMLCode(
              res.data.data.paymentHistory.length,
              months[+formValue.month - 1],
              formValue.year,
              data.fname + " " + data.lname,
              // this.state.doctorName,
              data.abn,
              data.un,
              data.streetName,
              data.suburb,
              data.state,
              data.postCode,
              data.email,
              rows,
              totalConsultConst,
              totalConsultConst,
              totalPMFee,
              totalTax,
              totalEarnings,
              "support@instantconsult.com.au",
              "1300 003 310"
            );
            let docH = 350;
            let docW = 600;
            html2pdf(element, {
              margin: 1,
              filename: "MonthlySummary.pdf",
              image: { type: "jpeg", quality: 1 },
              html2canvas: { letterRendering: false, docH, docW, scale: 2 },
              jsPDF: { unit: "mm", format: [docH, docW], orientation: "l" }
            });
          }
          closeSummaryModal();
          setIsProcessing(false);
        },
        failureCallback: err => {
          setIsProcessing(false);
          // setErrModalText(
          //   "Please try again. Please contact Instant Consult Support on 1300 003 310 if this issue persists."
          // );
          // setShowErrModal(true);
        }
      });
    } else {
      let startDate = moment([formValue.year, formValue.month - "1"]),
      endDate = moment(startDate).endOf("month");
    let paramData = {
      startDate: moment(startDate)
        .add(0, "d")
        .toISOString(),
      endDate: endDate.toISOString(),
      doctorId: id
    };
      setApiCallParams3({
        reqType: "GET",
        reqUrl: getPaymentSummariesListNew,
        params: paramData,
        successCallback: res => {
          let totalPMFee = 0,
          totalTax = 0,
          totalInvoices = 0,
          rows = "",
          monthlySummaryDataFormat = [];

        res.data.data.paymentHistory.map((value, index) => {
          let TotalInvoice = (value.taxAmount + value.PMFeeAmount).toFixed(2),
            createdAt = moment(value.createdAt).format("DD-MM-YYYY"),
            callMadeAt = moment(value.callMadeAt).format("DD-MM-YYYY");
          totalPMFee = totalPMFee + Number(value.PMFeeAmount);
          totalTax = totalTax + Number(value.taxAmount);
          totalInvoices = totalInvoices + Number(TotalInvoice);
          monthlySummaryDataFormat.push({
            appointmentId: value.appointmentId,
            createdAt: createdAt,
            PMFeeAmount: value.PMFeeAmount,
            taxAmount: value.taxAmount,
            totalInvoice: TotalInvoice
          });
        });

        if (formValue.csv) {
          monthlySummaryDataFormat.push({
            appointmentId: "-",
            createdAt: "-",
            PMFeeAmount: "$" + totalPMFee.toFixed(2),
            taxAmount: "$" + totalTax.toFixed(2),
            totalInvoice: "$" + totalInvoices.toFixed(2)
          });
          // this.setState({
          //   monthlySummaryCSV: monthlySummaryDataFormat
          // });
          setMonthlySummaryCSV(monthlySummaryDataFormat)
          // document.querySelector("#downloadCSV").click(); // pure js to get the click event + ref is not working with CSVLink element
          setTimeout(() => {
            csvInput.current.link.click();
          }, 2000);
        }
        if (formValue.pdf) {
          let months = [
            "January",
            "February",
            "March",
            "April",
            "May",
            "June",
            "July",
            "August",
            "September",
            "October",
            "November",
            "December"
          ];
          let element = generateTaxInvoiceHTMLCode(
            res.data.data.paymentHistory.length,
            months[+formValue.month - 1],
            formValue.year,
            res.data.data.doctorDetail[0].firstName + ' ' + res.data.data.doctorDetail[0].lastName,
            res.data.data.doctorDetail[0].ABN,
            res.data.data.doctorDetail[0].address.unitNumber,
            res.data.data.doctorDetail[0].address.streetNumber + " " + res.data.data.doctorDetail[0].address.streetName,
            res.data.data.doctorDetail[0].address.suburb,
            res.data.data.doctorDetail[0].address.state,
            res.data.data.doctorDetail[0].address.postCode,
            res.data.data.doctorDetail[0].email,
            rows,
            totalPMFee,
            totalTax,
            totalInvoices,
            "support@instantconsult.com.au",
            "1300 003 310"
          );
          
          // let element = this.generateHTMLCode(res.data.data.paymentHistory.length, months[(+formValue.month) - 1], formValue.year, this.state.doctorName, this.state.abn, this.state.unitNumber, this.state.streetNumber + " " + this.state.streetName, this.state.suburb, this.state.state, this.state.postCode, this.state.doctorEmail, rows, 12000, 1200, 250, this.state.supportEmail, this.state.supportPhone);
          let docH = 305;
          let docW = 600;
          html2pdf(element, {
            margin: 1,
            filename: "TaxInvoiceMonthlySummary.pdf",
            image: { type: "jpeg", quality: 1 },
            html2canvas: { letterRendering: false, docH, docW, scale: 2 },
            jsPDF: { unit: "mm", format: [docH, docW], orientation: "l" }
          });
        }

          closeSummaryModal();
          setIsProcessing(false);
        },
        failureCallback: err => {
          console.log("Error: ", err);
          setIsProcessing(false);
          // setErrModalText(
          //   "Please try again. Please contact Instant Consult Support on 1300 003 310 if this issue persists."
          // );
          // setShowErrModal(true);
          closeSummaryModal();
        }
      });
    }
  };

  
  const closeSummaryModal = () => {
    setOpenMonthlySummaryModel(false);
  };

  const exportDB4FormsSummary = () => {
    setOpenMonthlyDB4Forms(true);
  };

  const exportMonthlyConsult = () => {
    setOpenMonthlyConsults(true);
  };

  const downloadDB4Forms = formValue => {
    setIsProcessing(true);
    setOpenMonthlyDB4Forms(false);
    let startDate = moment([formValue.year, formValue.month - "1"]),
      endDate = moment(startDate).endOf("month");
    let paramData = {
      startDate: moment(startDate)
        .add(0, "d")
        .toISOString(),
      endDate: endDate.toISOString(),
      doctorId: id
    };

    setApiCallParams4({
      reqType: "POST",
      reqUrl: getDbFormsApi,
      dataObj: paramData,
      successCallback: res => {
        setOpenMonthlyDB4Forms(false);
        if (res.data.data.length === 0) {
          setNoDataFoundDB4(true);
        } else {
          let urls = res.data.data;
          urls.forEach((url, index) => {
            var a = document.createElement("a");
            a.target = "_blank";
            a.download =
              url.patientId.lastName +
              moment(url.acceptedAt).format("DDMMYYYY") +
              ".pdf";
            a.title =
              url.patientId.lastName +
              moment(url.acceptedAt).format("DDMMYYYY") +
              ".pdf";
            a.name =
              url.patientId.lastName +
              moment(url.acceptedAt).format("DDMMYYYY") +
              ".pdf";
            a.href = url.bbDB4FormLink;
            a.setAttribute(
              "download",
              url.patientId.lastName +
                moment(url.acceptedAt).format("DDMMYYYY") +
                ".pdf"
            );
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
          });
          setIsProcessing(false);
        }
      },
      failureCallback: err => {
        setIsProcessing(false);
        // setErrModalText(
        //   "Please try again. Please contact Instant Consult Support on 1300 003 310 if this issue persists."
        // );
        // setShowErrModal(true);
      },
      timeout: 180000
    });
  };

  const closeDB4FormsModal = () => {
    setOpenMonthlyDB4Forms(false);
  };

  const downloadMonthlyConsults = formValue => {
    setIsProcessing(true);
    setOpenMonthlyConsults(false);
    console.log("Form Values: ", formValue);

    if (formValue.csv === true) {
      console.log("Download CSV");
      let startDate = moment([formValue.year, formValue.month - "1"]),
        endDate = moment(startDate).endOf("month");
      let paramData = {
        startDate: moment(startDate)
          .add(0, "d")
          .toISOString(),
        endDate: endDate.toISOString(),
        doctorId: id
      };

      setApiCallParams4({
        reqType: "POST",
        reqUrl: getMonthlyConsultApi,
        dataObj: paramData,
        successCallback: res => {
          let monthlyConsultDataFormat = [];
          res.data.data.getData.map((value, index) => {
            let patientDeclaration = "";
            if (
              value.selectedCovidSituation &&
              value.selectedCovidSituation.includes("hot spot")
            ) {
              patientDeclaration =
                value.selectedCovidSituation.split("hot spot")[0] +
                "impacted area";
            } else if (
              value.selectedCovidSituation &&
              value.selectedCovidSituation.includes("impacted area")
            ) {
              patientDeclaration =
                value.selectedCovidSituation.split("impacted area")[0] +
                "impacted area";
            } else if (value.selectedCovidSituation) {
              patientDeclaration = value.selectedCovidSituation;
            }

            let pushData = {
              createdAt: moment(value.acceptedAt).format("DD-MM-YYYY"),
              firstName:
                value.patientId && value.patientId.firstName
                  ? value.patientId.firstName
                  : "",
              lastName:
                value.patientId && value.patientId.lastName
                  ? value.patientId.lastName
                  : "",
              dob:
                value.patientId && value.patientId.dateOfBirth
                  ? value.patientId.dateOfBirth
                  : "",
              patientDeclaration: patientDeclaration,
              url: value.bbDB4FormLink ? value.bbDB4FormLink : ""
            };

            monthlyConsultDataFormat.push(pushData);
          });

          // To download the pdfs of consult note ************************************************
          //
          // let allConsultData = res.data.data.getConsults;
          // let consultNoteDataArr = [];
          // _.forEach(res.data.data.getData, function(value) {
          //   let filterData = _.filter(allConsultData, (o) => {
          //     return ((value.patientId._id === o.patientId._id) && (moment(value.acceptedAt).format("DD-MM-YYYY") === moment(o.createdAt).format("DD-MM-YYYY")));
          //   });
          //   if(filterData.length){
          //     consultNoteDataArr.push(filterData);
          //   }
          // });
          // console.log("Medicare Consults: ", res.data.data.getData.length);
          // console.log("Filter Data: ", consultNoteDataArr);
          // console.log("Consult Note Lenths: ", consultNoteDataArr.length);
          // ************************************************************************************************

          if (res.data.data.getData.length === 0) {
            setNoDataFoundDB4(true);
          } else {
            setMonthlyConsultCSV(monthlyConsultDataFormat);
            setTimeout(() => {
              csvDownRefMonthlyConsult.current.link.click();
              // processPDFFiles(consultNoteDataArr); // to download the pdf of consult
            }, 2000);
          }
          setOpenMonthlyConsults(false);

          setIsProcessing(false);
        },
        failureCallback: err => {
          console.log("Getting some error: ", err);
          setIsProcessing(false);
          // setErrModalText(
          //   "Please try again. Please contact Instant Consult Support on 1300 003 310 if this issue persists."
          // );
          // setShowErrModal(true);
          //setOpenMonthlyConsults(false);
        },
        timeout: 180000
      });
    } else {
      setIsProcessing(false);
      // upload csv modal open
      setUploadConsultNoteCSVModal(true);
    }
  };

  const closeMonthlyConsultModal = () => {
    setOpenMonthlyConsults(false);
  };

  const handleCSVUpload = file => {
    console.log("Got the file: ", file);
    setUploadConsultNoteCSVModal(false);
    setIsProcessing(true);

    let formData = new FormData();
    formData.append("csvFile", file);
    formData.append("doctorId", id);

    setApiCallParams5({
      reqType: "POST",
      reqUrl: uploadMedicareConsultNoteCSVApiRoute,
      dataObj: formData,
      successCallback: res => {
        setIsProcessing(false);
        console.log("Getting this data for pdf: ", res.data.data);
        // now process pdfs
        // processPDFFiles(res.data.data.consultNotes);
        if (
          res.data.data.consultNotes.length &&
          res.data.data.notFoundData.length === 0
        ) {
          setConsultDataForGeneratePDFs(res.data.data.consultNotes);
          processPDFFiles(res.data.data.consultNotes);
        }
        if (
          res.data.data.consultNotes.length === 0 &&
          res.data.data.notFoundData.length === 0
        ) {
          setNoDataFoundDB4(true);
        }
        if (res.data.data.notFoundData.length) {
          setConsultDataForGeneratePDFs(res.data.data.consultNotes);
          setConsultDataNotFoundPDF(res.data.data.notFoundData);
          setConsultDataContinueProcessModal(true);
        }
      },
      failureCallback: err => {
        console.log("Something went wrong: ", err);
        setIsProcessing(false);
        // setErrModalText(
        //   "Please try again. Please contact Instant Consult Support on 1300 003 310 if this issue persists."
        // );
        // setShowErrModal(true);
      }
    });
  };

  const processPDFFiles = consultNoteDataArr => {
    setIsProcessing(true);
    let chunkArr = _.chunk(consultNoteDataArr, 6);
    console.log("Chunk arr: ", chunkArr);
    if (chunkArr.length === 0) {
      setIsProcessing(false);
    }
    chunkArr.forEach((consultNoteData, index) => {
      // let timer = index === 0 ? 0 : 1;
      setTimeout(() => {
        console.log("Inside timeout");
        let count = 0;
        console.log("==== While Loop Starts ====");
        while (count < consultNoteData.length) {
          if (
            consultNoteData[count][0] &&
            consultNoteData[count][0].patientId &&
            consultNoteData[count][0].patientId.patientId
          ) {
            let patientName =
              consultNoteData[count][0].patientId.firstName +
              " " +
              consultNoteData[count][0].patientId.lastName;
            let gender = consultNoteData[count][0].patientId.gender;
            let dob =
              "DOB: " +
              getFormattedMonthDate(
                consultNoteData[count][0].patientId.dateOfBirth
              ) +
              " (" +
              getAgeByYears(consultNoteData[count][0].patientId.dateOfBirth) +
              " years of age)";
            let uin = consultNoteData[count][0].patientId.patientId;
            let consultDate = "";
            let doctorName = "";
            if (consultNoteData[count][0].doctorId) {
              doctorName =
                "Consulted with Dr. " +
                consultNoteData[count][0].doctorId.firstName +
                " " +
                consultNoteData[count][0].doctorId.lastName +
                " | UIN: " +
                consultNoteData[count][0].doctorId.doctorId;
            }
            console.log("Chunk Array Inside Main Loop: ", count);
            for (let i = 0; i < consultNoteData[count].length; i++) {
              console.log("Inside Inner Loop: ", i);
              consultDate =
                getWeekDay(consultNoteData[count][i].createdAt) +
                ", " +
                getFormattedMonthDateV3(consultNoteData[count][i].createdAt);
              let notesDataJson = "";
              let attachmentDesign = "";
              let instantConsultAttachments = consultNoteData[count][i].attachments || [];
              let instantSwitchAttachments = consultNoteData[count][i].instantSwitchAttachments || [];
              let attachments = [...instantConsultAttachments, ...instantSwitchAttachments];
              try {
                console.log("Json array try: ", consultNoteData[count][i]);
                if (consultNoteData[count][i].note) {
                  let jsonData = JSON.parse(consultNoteData[count][i].note);
                  if (jsonData.presentingComplaint && jsonData.impression) {
                    notesDataJson = `
                        <div class="w-100"></div>
                        <div class="col-sm-4 d-flex flex-row">
                            <p class="insta-label small light mb-0 word-break-all">Billing Note: ${jsonData.billingNote || '-'}</p>
                        </div>
                        <div class="w-100"></div>
                        <div class="col-sm-4 d-flex flex-row">
                            <p class="insta-label small light mb-0">Presenting Complaint: ${jsonData.presentingComplaint || '-'}</p>
                        </div>
                        <div class="w-100"></div>
                        <div class="col-sm-4 d-flex flex-row">
                            <p class="insta-label small light mb-0">Impression: ${jsonData.impression || '-'}</p>
                        </div>
                        <div class="w-100"></div>
                        <div class="col-sm-4 d-flex flex-row">
                            <p class="insta-label mb-0 small light mb-0">Plan: ${jsonData.plan || '-'}</p>
                        </div>
                        <div class="w-100"></div>
                        `;
                    if (
                      jsonData.investigations &&
                      jsonData.investigations !== ""
                    ) {
                      notesDataJson += `
                          <div class="col-sm-4 d-flex flex-row">
                            <p class="insta-label small light mb-0">Investigations: ${jsonData.investigations}</p>
                          </div>
                          <div class="w-100"></div>
                          `;
                    }
                  } else if (consultNoteData[count][i].note !== '' && typeof consultNoteData[count][i].note === "string") {
                    notesDataJson = `
                          <div class="w-100"></div>
                          <div class="col-sm-4 d-flex flex-row">
                              <p class="insta-label small light mb-0">${data.note.replace(/\r?\n/g, "<br/>")}</p>
                          </div>
                          <div class="w-100"></div>
                        `;
                  }
                }
              } catch {
                console.log("Just String");
                if (consultNoteData[count][i].notes) {
                  notesDataJson = `
                    <div class="w-100"></div>
                    <div class="col-sm-4 d-flex flex-row">
                        <p class="insta-label small light mb-0">${consultNoteData[count][i].notes}</p>
                    </div>
                    <div class="w-100"></div>
                  `;
                }
              }

              if (
                attachments &&
                attachments.length
              ) {
                console.log("Adding Attachments");
                for (
                  let j = 0;
                  j < attachments.length;
                  j++
                ) {
                  attachmentDesign += `
                    <div class="col-sm-3 p-1 consult-note-dropdown-group">
                      <div class="btn-group">
                          <a href="#" class="link insta-link-default consult-note-pdf-btn font-12 ${attachments[j].type === 'Online Assessment' || attachments[j].type === 'Treatment Plan' ? 'gray-bg-new-color' : ''}" target="_blank"> ${attachments[j].type === 'Online Assessment' || attachments[j].type === 'Treatment Plan' ? "<img src='" + EnvalopePNG + "' class='envelop-img' />" : 'PDF'} </a>
                          <a href="#" target="_blank">
                              <button type="button" class="insta-button-primary gray small border-radius-0 pl-2 pr-2 m-0 text-left consult-note-btn font-12 btn btn-primary">${attachments[j].type}.pdf</button>
                          </a>
                          <div class="btn-group">
                              <button type="button" aria-haspopup="true" aria-expanded="false" class="dropdown-toggle-icon btn" style="border-top-right-radius: 0px;border-bottom-right-radius: 0px;background-color: #dae0e5; border-color: #dae0e5; padding-top: 0px">
                                  <img src=${menuSVG} alt="menubar" style="width:15px" />
                              </button>
                          </div>
                      </div>
                  </div>
                  `;
                }
              }

              let renameFileName =
                consultNoteData[count][0].patientId.firstName +
                consultNoteData[count][0].patientId.lastName +
                moment(consultNoteData[count][i].createdAt).format("DDMMYYYY") +
                ".pdf";
              generateConsultNotePDF(
                patientName,
                gender,
                dob,
                uin,
                consultDate,
                notesDataJson,
                attachmentDesign,
                doctorName,
                renameFileName
              );
            }
          }
          count++;
        }
        console.log("==== While Loop Ends ====");
        console.log("Index & Length, ", index, chunkArr.length);
        if (index + 1 >= chunkArr.length) {
          setIsProcessing(false);
        } else {
          setIsProcessing(true);
        }
      }, 35000 * index);
    });
  };

  const generateConsultNotePDF = async (
    patientName,
    gender,
    dob,
    uin,
    consultDate,
    notesDataJson,
    attachmentDesign,
    doctorName,
    renameFileName
  ) => {
    console.log("Generate PDF Called");
    let element = consultNoteGenerateHTMLCode(
      patientName,
      gender,
      dob,
      uin,
      consultDate,
      notesDataJson,
      attachmentDesign,
      doctorName
    );
    let docH = 450;
    let docW = 600;
    html2pdf(element, {
      margin: 1,
      filename: renameFileName,
      image: { type: "jpg", quality: 1 },
      html2canvas: { letterRendering: false, docH, docW, scale: 2 },
      jsPDF: { unit: "mm", format: [docH, docW], orientation: "l" }
    }).then(pdf => {
      console.log("PDF generated: ", pdf);
    });
  };

  const handleContinueProcessPDF = () => {
    setIsProcessing(true);
    setConsultDataContinueProcessModal(false);
    setTimeout(() => {
      processPDFFiles(consultDataForGeneratePDFs);
    }, 1500);
  };



  return (
    <div className="view-ticket-container doctor-profile-page-container">
      <CustomModal
        useOneButton={true}
        cancelText="OKAY"
        openModal={showErrModal}
        cancelEvent={() => {
          setShowErrModal(false);
          setErrModalText("");
        }}
        modalBodyContent={<p className="text-center mb-0">{errModalText}</p>}
      />
      <CustomModal
        useOneButton={true}
        cancelText="OKAY"
        openModal={showSuccModal}
        cancelEvent={() => {
          setShowSuccModal(false);
          setSuccModalText("");
          history.push(appRoutes.doctorRejected, {
            currPageNo:
              props.location.state && props.location.state.currPageNo
                ? props.location.state.currPageNo
                : null
          });
        }}
        modalBodyContent={<p className="text-center mb-0">{succModalText}</p>}
      />
      {isProcessing && <Loader />}
      <div className={isProcessing ? "disableContainer" : ""}>
        <NavLink
          to={{
            pathname: appRoutes.doctorRejected,
            state: {
              currPageNo:
                props.location.state && props.location.state.currPageNo
                  ? props.location.state.currPageNo
                  : null
            }
          }}
          className="details-back-link"
          href="#"
        >
          <i className="fas fa-arrow-left"></i>{" "}
          <span className="ml-1 back-btn-text"> Back to Rejected</span>
        </NavLink>
        <h3 className="mt-4">Rejected</h3>

        <br />
        {/* <DoctorProfileForm
          onSubmitForm={onFormSubmit}
          onCancelForm={onCancelForm}
          data={data}
          states={STATE_LIST}
          isRejectedProfile={true}
          exportMonthlySummary={exportMonthlySummary}
          showExportBtn={true}
        /> */}
        <DoctorProfileForm
          onSubmitForm={onFormSubmit}
          onCancelForm={onCancelForm}
          data={data}
          states={STATE_LIST}
          isRejectedProfile={true}
          exportMonthlySummary={exportMonthlySummary}
          exportDB4FormsSummary={exportDB4FormsSummary}
          exportMonthlyConsult={exportMonthlyConsult}
          showExportBtn={true}
        />
        <br />
        <br />
      </div>
      {/* API Call */}
      <MakeAPICall apiParam={apiCallParams1} />
      {/*<MakeAPICall apiParam={apiCallParams2} />*/}
      <MakeAPICall apiParam={apiCallParams3} />
      <MakeAPICall apiParam={apiCallParams4} />
      <MakeAPICall apiParam={apiCallParams5} />

      <CustomModal
        openModal={consultDataContinueProcessModal}
        title="Records Not Found"
        cancelText="Cancel"
        cancelEvent={() => {
          setConsultDataContinueProcessModal(false);
          setIsProcessing(false);
        }}
        okayText="Continue"
        okayEvent={handleContinueProcessPDF}
        modalBodyContent={
          <Fragment>
            <ul className="list-group">
              {consultDataNotFoundPDF.map((value, index) => {
                return (
                  <li className="list-group-item" key={index}>
                    <p className="w-50 float-left mb-0">
                      Last Name: {value["Last Name"]}
                    </p>
                    <p className="w-50 float-left mb-0">
                      First Name: {value["First Name"]}
                    </p>
                    <p className="w-50 float-left mb-0">DOB: {value["DOB"]}</p>
                    <p className="w-50 float-left mb-0">
                      Date of Consult: {value["Date of Consult"]}
                    </p>
                  </li>
                );
              })}
            </ul>
          </Fragment>
        }
      />

<CustomModal
        useOneButton={true}
        cancelText="OKAY"
        openModal={noDataFoundDB4}
        cancelEvent={() => {
          setNoDataFoundDB4(false);
        }}
        modalBodyContent={<p className="text-center mb-0">No Data Found</p>}
      />


      <MonthlySummaryModel
        openModal={openMonthlySummaryModel}
        okayText="Okay"
        cancelText="Cancel"
        title="Export Monthly Summary Report"
        useOneButton={false}
        onFormSubmit={downloadMonthlySummary}
        cancelEvent={closeSummaryModal}
      />
      <MonthlyDB4Forms
        openModal={openMonthlyDB4Forms}
        okayText="Okay"
        cancelText="Cancel"
        title="Export DB4 Forms"
        useOneButton={false}
        onFormSubmit={downloadDB4Forms}
        cancelEvent={closeDB4FormsModal}
      />
      <MonthlyDB4Forms
        openModal={openMonthlyConsults}
        okayText="Okay"
        cancelText="Cancel"
        title="Export Monthly Medicare Audit"
        useOneButton={false}
        onFormSubmit={downloadMonthlyConsults}
        cancelEvent={closeMonthlyConsultModal}
      />

      <CustomModal
        noFooterButtons={true}
        title="Upload CSV File"
        openModal={uploadConsultNoteCSVModal}
        modalBodyContent={
          <UploadMedicareConsultCSVForm
            onSheetSubmit={handleCSVUpload}
            closeModal={() => {
              setUploadConsultNoteCSVModal(false);
              setIsProcessing(false);
            }}
          />
        }
      />

      <CSVLink
        style={{ display: "none" }}
        ref={csvDownRef}
        className="no-text-decoration"
        filename={"Monthly_Summary.csv"}
        data={monthlySummaryCSV}
        headers={headers}
      ></CSVLink>

      <CSVLink
        id="downloadCSV"
        style={{ display: "none" }}
        ref={csvInput}
        filename={"Tax_Invoice_Monthly_Summary.csv"}
        data={monthlySummaryCSV}
        headers={taxInvoiceHeaders}
      ></CSVLink>

      <CSVLink
        style={{ display: "none" }}
        ref={csvDownRefMonthlyConsult}
        className="no-text-decoration"
        filename={"Monthly_Summary.csv"}
        data={monthlyConsultCSV}
        headers={headersConsult}
      ></CSVLink>
    </div>
  );
};

export default DoctorRejectedDetail;
